import * as yup from "yup";
import i18n from "../../../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const emailRequired = () => i18n.t("validation.emailRequired", {ns: "common"});

export const apiIntegrationMailFormValidations = yup.object().shape({
    emailAddress: yup
        .string()
        .email(emailRequired)
        .required(requiredMessage)
});
